import styled, {css} from 'styled-components';
import {getObjectProp} from '../utils/helpers/object';

const StyledPageHero = styled.div`
  width: 100%;
  position: relative;
  margin: 0 auto;
  max-width: ${({fixed}) => (fixed ? '1440px' : null)};
`;

export const StyledSliderContainer = styled.div`
  ${({theme}) => css`
    width: 100%;
    ${theme.breakpoints.down('sm')} {
      height: 200px;
    }
    ${theme.breakpoints.up('sm')} {
      height: 350px;
    }
    ${theme.breakpoints.up('md')} {
      height: 500px;
    }
    ${theme.breakpoints.up('lg')} {
      height: 650px;
    }
  `}
  .slick-slider, .slick-list, .slick-track, .slick-slide > div {
    height: 100%;
  }
`;

export const StyledSlide = styled.div`
  height: 100%;
`;

export const StyledSlideImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${({src}) => src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: inherit;
`;

export const StyledThumbSlider = styled.div`
  width: 100%;
  height: auto;
  margin: 10px 0 20px 0;
  padding: 0 30px 0 20px;
  .slick-prev {
    left: -20px;
  }
`;

export const StyledSliderThumb = styled.div`
  padding: 0 4px;
  border-radius: 6px;
  overflow: hidden;
  max-width: 100%;
  width: 70px;
  height: 40px;

  ${({theme}) => theme.breakpoints.up('sm')} {
    width: 240px;
    height: 120px;
    padding: 0 10px;
  }
`;

export const StyledSliderArrow = styled.button`
  ${({direction}) => css`
    &&,
    &:active,
    &:focus,
    &:hover {
      color: ${({theme}) => getObjectProp(theme, 'palette.text.primary')};
    }

    ${direction === 'left' &&
    css`
      i {
        transform-origin: center;
        transform: rotate(180deg);
      }
    `};

    &:before {
      display: none;
    }
  `}
`;

export default StyledPageHero;
